import { format } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import { DUBAI_SECTOR, RIYADH_SECTOR } from "@/core/constants/sectors";

const DEFAULT_TIME_ZONE = "Asia/Karachi";

const SECTOR_TIME_ZONES: Record<string, string> = {
  [DUBAI_SECTOR]: "Asia/Dubai",
  [RIYADH_SECTOR]: "Asia/Riyadh",
};

const WALL_CLOCK_REGEX =
  /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/;

export const PNR_EXPIRY_FORMAT = "dd MMM yyyy - HH:mm:ss";

export const parseWallClock = (
  value: string | null | undefined,
): Date | null => {
  const match = WALL_CLOCK_REGEX.exec((value ?? "").trim());
  if (!match) return null;

  const [, year, month, day, hours, minutes, seconds] = match;
  const parsed = new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hours),
    Number(minutes),
    Number(seconds ?? 0),
  );
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatWallClock = (
  value: string | null | undefined,
  dateFormat: string = PNR_EXPIRY_FORMAT,
): string => {
  const raw = (value ?? "").trim();
  if (!raw) return "";

  const parsed = parseWallClock(raw);
  return parsed ? format(parsed, dateFormat) : raw;
};

/**
 * "Now" as wall-clock time in the current sector's timezone, so it can be
 * compared with a date parsed by `parseWallClock`.
 */
export const getSectorNow = (now: Date = new Date()): Date => {
  const sectorName = localStorage.getItem("sector") || "";
  return toZonedTime(now, SECTOR_TIME_ZONES[sectorName] || DEFAULT_TIME_ZONE);
};
